import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Menu, MenuItem, Typography, useTheme } from '@mui/material';
import { userModel } from 'entities/user';
import { Chains, Icon, useModal, useShallowSelector } from 'shared';

export const ChainSelector = () => {
  const { network } = useShallowSelector(userModel.selectors.selectUserWeb3Info);
  const theme = useTheme();
  const popoverRef = useRef(null);
  const [isSelectorOpen, onOpenSelector, onCloseSelector] = useModal(false);
  const dispatch = useDispatch();

  const handleSwitchNetwork = (chain: Chains) => {
    if (network !== chain) {
      dispatch(userModel.userActions.updateUserState({ network: chain }));
    }
    onCloseSelector();
  };

  return (
    <>
      <Button
        ref={popoverRef}
        variant="outlined"
        onClick={onOpenSelector}
        endIcon={<Icon type="arrow-down" width={10} />}
        startIcon={<Icon type={network} />}
      >
        {network}
      </Button>
      <Menu
        anchorEl={popoverRef.current}
        open={isSelectorOpen}
        slotProps={{
          paper: {
            sx: {
              ml: { xs: 0, md: -2 },
              width: { xs: '100%', md: 482 },
            },
          },
        }}
        onClose={onCloseSelector}
        sx={{
          '.MuiBackdrop-root': { background: { xs: theme.themeColors.colorMenuBackdrop, md: 'transparent' } },
        }}
      >
        {Object.values(Chains).map((value) => (
          <MenuItem key={value} onClick={() => handleSwitchNetwork(value)}>
            <Icon type={value} size={42} />
            <Typography variant="button" sx={{ ml: '10px' }}>
              {value}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
